import { render, staticRenderFns } from "./GenerateUnpaidLeave.vue?vue&type=template&id=55cfc442"
import script from "./GenerateUnpaidLeave.vue?vue&type=script&lang=js"
export * from "./GenerateUnpaidLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports